import { ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { AssessmentService } from 'src/app/services/assessment.service';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-reports-tab',
  templateUrl: './reports-tab.component.html',
  styleUrl: './reports-tab.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ReportsTabComponent implements OnInit {

  edit_fire = signal<boolean>(false);

  //data
  @Input() fire?: any;
  @Input() reports: any;
  @Input() updateFireSubject?: Subject<any>;
  @Input() user: any;

  //access
  @Input() isEditable = false;

  constructor(
    private readonly titleService: Title,
    private readonly reportsService: ReportService,
    private readonly toast: ConfirmationToastComponent,
    private readonly assessmentService: AssessmentService,
  ) {
    this.titleService.setTitle("BAER - 2500-8 Reports")
  }

  ngOnInit(): void {
    this.titleService.setTitle(`BAER - ${this.fire.baer_name} 2500-8 Reports`)
  }

  createInterimReport() {
    let report_num_list = this.reports.map((report: any) => { return report.report_num });
    const next_report_num = Math.max(...report_num_list) + 1;
    this.reportsService.createReport(this.fire, next_report_num).subscribe({
      next: (response) => {
        this.toast.openSuccessSnackBar(`An interim report for ${this.fire.baer_name} has been created.`);
        this.updateFireSubject?.next(null)
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error creating the interim report.`, "Please try again.");
      },
    })
  }

  checkCreateInitialReport(): boolean {
    return (this.fire.assessment_status_id == 1 || this.fire.assessment_status_id == 3 || this.fire.assessment_status_id == 4 || this.fire.assessment_status_id == 12)
      && (this.reports?.length == 0 || ((this.fire.reports[this.fire.reports?.length - 1]?.report_type ?? '') == 'Pre-assessment Request'))
      && (this.user.isTeamLead || this.user.isROCO || this.user.isFOCO)
  }

  checkCreateInterimReport(): boolean {
    return ((this.fire.assessment_status_id >= 3) && this.fire.reports?.length >= 1)
      && ((this.fire.reports[this.fire.reports?.length - 1].initial_report_type ?? '') != '')
      && ((this.fire.reports[this.fire.reports?.length - 1].report_type ?? '') != 'Pre-assessment Request')
      && (this.user.isTeamLead || this.user.isROCO || this.user.isFOCO)
  }

  createInitialReport() {
    this.assessmentService.editAssessment({
      assessment_id: this.fire.assessment_id,
      assessment_status_id: 3
    }).subscribe({
      next: (response) => { },
      error: (response) => { },
    })
    this.reportsService.createReport(this.fire, 1).subscribe({
      next: (response) => {
        this.toast.openSuccessSnackBar(`An initial report for ${this.fire.baer_name} has been created.`);
        this.updateFireSubject?.next(null)
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error creating the initial report.`, "Please try again.");
      },
    })
  }
}
